import { flatMap, get } from "lodash";
import $axios from "../../services/api.js";
// import { search } from "core-js/fn/symbol";
const state = () => ({
    loading: false,

    form_visitor: {
        date: new Date(),
        ip_address: ""
    },
    message_visitor: "",

    sliders: [],
    loading_slider: false,

    recomendproductx: [],
    loading_recomendproductx: false,
    
    specialoffers: [],
    loading_specialoffers: false,

    news: [],
    loading_news: false,

    message_token: "",

    loading_news_id: false,
    news_read_by_id: [],

    loading_job_id: false,
    job_detail_by_id: [],

    isLoading: false,
    searchResult: [],

    faq: [],
    loading_faq: false,
});
const mutations = {
    CLEAR_STATE(state) {
        state.loading = false,
            state.sliders = {};
            state.loading_slider = false,
            state.recomendproductx = [],
            state.loading_recomendproductx = false,
            state.specialoffers = [],
            state.loading_specialoffers = false,
            state.news = [],
            state.loading_news = false,
            state.after_sale = [],
            state.loading_after_sale = false
            state.loading_news_id = false,
            state.news_read_by_id = [],
            state.loading_job_id = false,
            state.job_detail_by_id = [];
            state.isLoading = false;
            state.searchResult = [];
            state.faq = [];
            state.loading_faq = false;
    },
    ASSIGN_DATA_SLIDER(state, payload) {
        state.sliders = payload;
    },
    // ASSIGN_DATA_ICONS(state, payload) {
    //     state.icons = payload;
    // },
    ASSIGN_DATA_RECOMENDED(state, payload) {
        state.recomendproductx = payload;
    },
    ASSIGN_DATA_SPECIAL_OFFERS(state, payload) {
        state.specialoffers = payload;
    },
    ASSIGN_DATA_NEWS(state, payload) {
        state.news = payload;
    },
    ASSIGN_DATA_AFTER_SALE(state, payload) {
        state.after_sale = payload;
    },
    CLEAR_CAR_NAME(state) {
        state.car_name = [];
    },
    ASSIGN_MESSAGE_VISITOR(state, payload) {
        state.message_form_visitor = payload
    },
    ASSIGN_MESSAGE_TOKEN(state, payload) {
        state.message_token = payload
    },
    CLEAR_MESSAGE_TOKEN(state) {
        state.message_token = ""
    },
    ASSIGN_DATA_NEWS_BY_ID(state, payload) {
        state.news_read_by_id = payload
    },
    ASSIGN_DATA_JOB_BY_ID(state, payload) {
        state.job_detail_by_id = payload
    },
    ASSIGN_DATA_SEARCH_RESULT(state, payload) {
        state.searchResult = payload
    },
    ASSIGN_DATA_FAQ(state, payload) {
        state.faq = payload
    },
};
const actions = {
    // Destroy State
    Clear_State({ commit }) {
        return new Promise(() => {
            commit("CLEAR_STATE");
        });
    },

    cekToken({
        commit,
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            $axios.post(`auth`, {
                email: payload.email,
                token: payload.token
            })
                .then((response) => {
                    commit('ASSIGN_MESSAGE_TOKEN', response.data.message)
                    resolve(response.data)
                }).catch((error) => {
                    commit('SET_ERRORS', "Server Bermasalah", {
                        root: true
                    })
                    reject(error)
                })
        })
    },
    Send_Visitor({
        commit,
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            $axios.post(`visitor`, state.form_visitor)
                .then((response) => {
                    commit('ASSIGN_MESSAGE_VISITOR', response.data.message)
                    resolve(response.data)
                }).catch((error) => {
                    commit('SET_ERRORS', "Server Bermasalah", {
                        root: true
                    })
                    reject(error)
                })
        })
    },
    getSlider({
        commit,
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            state.loading_slider = true;
            $axios.get(`careersliders`)
                .then((response) => {
                    commit('ASSIGN_DATA_SLIDER', response.data.data)
                    state.loading_slider = false;
                    resolve(response.data)
                })
                .catch((error) => {
                    // Reset flag loading agar halaman tidak blank saat API gagal.
                    state.loading_slider = false;
                    reject(error);
                })
        })
    },
    getRecomended({
        commit,
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            state.loading_recomendproductx = true;
            $axios.get(`careerpositions/highlight`)
                .then((response) => {
                    commit('ASSIGN_DATA_RECOMENDED', response.data.data)
                    state.loading_recomendproductx = false;
                    resolve(response.data)
                })
                .catch((error) => {
                    // Reset flag loading agar halaman tidak blank saat API gagal.
                    state.loading_recomendproductx = false;
                    reject(error);
                })
        })
    },
    getSpecialOffers({
        commit,
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            state.loading_specialoffers = true;
            $axios.get(`careerspecialevents`)
                .then((response) => {
                    commit('ASSIGN_DATA_SPECIAL_OFFERS', response.data.data)
                    state.loading_specialoffers = false;
                    resolve(response.data)
                })
                .catch((error) => {
                    // Reset flag loading agar halaman tidak blank saat API gagal.
                    state.loading_specialoffers = false;
                    reject(error);
                })
        })
    },
    getNews({
        commit,
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            state.loading_news = true;
            $axios.get(`careernews/highlight`)
                .then((response) => {
                    commit('ASSIGN_DATA_NEWS', response.data.data)
                    state.loading_news = false;
                    resolve(response.data)
                })
                .catch((error) => {
                    // Reset flag loading agar halaman tidak blank saat API gagal.
                    state.loading_news = false;
                    reject(error);
                })
        })
    },
    getNewsbyID({
        commit,
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            //REQUEST DATA DENGAN ENDPOINT /LIST ITEMS
            state.loading_news_id = true;
            $axios.get(`careernewsdetail/${payload}`)
                .then((response) => {
                    //SIMPAN DATA KE STATE MELALUI MUTATIONS
                    commit('ASSIGN_DATA_NEWS_BY_ID', response.data.data.career_blog_detail)
                    state.loading_news_id = false;
                    resolve(response.data)
                })
                .catch((error) => {
                    // Reset flag loading agar halaman tidak blank saat API gagal.
                    state.loading_news_id = false;
                    reject(error);
                })
        })
    },
    getJobDetailByID({
        commit,
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            state.loading_job_id = true;
            $axios.get(`careerdetail/${payload}`)
                .then((response) => {
                    commit('ASSIGN_DATA_JOB_BY_ID', response.data.data.job)
                    state.loading_job_id = false;
                    resolve(response.data)
                })
                .catch((error) => {
                    // Reset flag loading agar halaman tidak blank saat API gagal.
                    state.loading_job_id = false;
                    reject(error);
                })
        })
    },
    getSearchResult({
        commit,
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            state.isLoading = true;
            $axios.post(`careersearch/result`, payload)
                .then((response) => {
                    commit('ASSIGN_DATA_SEARCH_RESULT', response.data.data)
                    state.isLoading = false;
                    resolve(response.data)
                })
                .catch((error) => {
                    // Reset flag loading agar halaman tidak blank saat API gagal.
                    state.isLoading = false;
                    reject(error);
                })
        })
    },
    fetchFaqs({
        commit,
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            state.loading_faq = true;
            $axios.get(`careerfaqs`)
                .then((response) => {
                    commit('ASSIGN_DATA_FAQ', response.data.data)
                    state.loading_faq = false;
                    resolve(response.data)
                })
                .catch((error) => {
                    // Reset flag loading agar halaman tidak blank saat API gagal.
                    state.loading_faq = false;
                    reject(error);
                })
        })
    },
};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
